import React, { useState } from "react";
import PortfolioGridTable from "../../layouts/PortfolioGridTable";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import CardMUI from "../../layouts/CardMUI";
import PropTypes from "prop-types";
import PortfolioGridHSTable from "../../layouts/PortfolioGridHSTable";
import PortfolioGridOCTable from "../../layouts/PortfolioGridOCTable";
import PortfolioGridPSTable from "../../layouts/PortfolioGridPSTable";
import PortfolioGridESGTable from "../../layouts/PortfolioGridESGTable";
import PortfolioGridAMTable from "../../layouts/PortfolioGridAMTable";

const Portfolio = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [overviewItem, setOverviewItem] = useState([
    { Industry: "Financial" },
    { "HQ Address": "Toronto Downtown" },
    { "Total Employee Number": 55000 },
    { "Total Square Footage Managed": "1,000,000 sq ft" },
    { "Total Number of Buildings": 50 },
  ]);
  const [KPIinfo, setKPIinfo] = useState([
    { "Avg Employee Satisfaction Score": 4.5 },
    {
      "Overall Condition Summary": [
        { desc: "Excellent", value: 40 },
        { desc: "Good", value: 50 },
        {
          desc: "Fair",
          value: 10,
        },
      ],
    },
    {
      "Well Certification Levels": [
        { desc: "Silver", value: 10 },
        { desc: "Gold", value: 20 },
        {
          desc: "Platinum",
          value: 30,
        },
      ],
    },
    {
      "LEED Certification Levels": [
        { desc: "Silver", value: 5 },
        { desc: "Gold", value: 15 },
        {
          desc: "Platinum",
          value: 30,
        },
      ],
    },
  ]);

  function handleChangeTab(event, newValue) {
    setActiveTab(newValue);
  }

  // Set Tabs props
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        className="w-100 overflow-auto"
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ bgcolor: "#072545", color: "white" }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  return (
    <>
      <div
        className="px-sm-5  px-2 w-100 h-100 d-flex flex-column overflow-hidden"
        style={{ backgroundColor: "#062545" }}
      >
        {/* Portfolio header */}
        <div className="w-100 d-flex flex-column my-2">
          {/* General Information */}
          <div className="row w-100 g-0 overflow-hidden gap-3">
            <div className="col-12">
              <CardMUI
                title={"Contoso Financial"}
                generalInfo={overviewItem}
                KPIinfo={KPIinfo}
                logo={"/images/contoso-logo.png"}
              />
            </div>
          </div>
        </div>

        {/* Content */}
        <div
          className="mb-2 overflow-hidden"
          style={{ backgroundColor: "#072545" }}
        >
          <Box sx={{ width: "100%" }}>
            {/* Navigation Tabs */}
            <Box
              sx={{ borderBottom: 1, borderColor: "divider", marginBottom: 2 }}
            >
              <Tabs
                value={activeTab}
                onChange={handleChangeTab}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Overview"
                  {...a11yProps(0)}
                  sx={{ color: "white", fontSize: "10px" }}
                  icon={<FeedOutlinedIcon sx={{ color: "white" }} />}
                  aria-label="overview"
                  iconPosition="top"
                />
                <Tab
                  label="Health & Safety"
                  {...a11yProps(1)}
                  sx={{ color: "white", fontSize: "10px" }}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 27 26"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.457364 11.5C-0.561836 8.45597 0.125472 4.93036 2.4882 2.50797C4.96064 -0.0268894 8.74863 -0.726149 11.9101 0.805288C12.6913 1.18372 13.4068 1.68365 14.0327 2.28457C14.4678 1.82539 14.9611 1.42696 15.5001 1.10033C18.2662 -0.57601 21.7884 -0.119414 24.0605 2.21005L24.6325 2.79647C26.9279 5.14986 27.5542 8.56648 26.5113 11.5H18.927L17.25 8.29712L15 12.5929L10.5 4L6.5715 11.5H0.457364ZM2.08065 14.3647C2.19757 14.5009 2.31943 14.6341 2.44625 14.7641L13.4054 26L13.4197 25.9854L13.4339 26L21.8916 17.3255L24.6314 14.5175C24.6806 14.4671 24.7291 14.4161 24.7767 14.3647H17.427L15 19L10.5 10.4057L8.42705 14.3647H2.08065Z"
                        fill="white"
                      />
                    </svg>
                  }
                  aria-label="health"
                  iconPosition="top"
                />
                <Tab
                  label="Occupancy"
                  {...a11yProps(2)}
                  sx={{ color: "white", fontSize: "10px" }}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 26 25"
                      fill="none"
                    >
                      <path
                        d="M26.0034 18C26.0034 16.6155 25.5929 15.2622 24.8237 14.111C24.0545 12.9599 22.9613 12.0627 21.6822 11.5328C20.4031 11.003 18.9957 10.8644 17.6378 11.1345C16.2799 11.4046 15.0326 12.0713 14.0537 13.0503C13.0747 14.0292 12.408 15.2765 12.1379 16.6344C11.8678 17.9922 12.0065 19.3997 12.5363 20.6788C13.0661 21.9579 13.9633 23.0511 15.1144 23.8203C16.2656 24.5895 17.619 25 19.0034 25V24.3711C17.7433 24.3711 16.5116 23.9974 15.4639 23.2973C14.4161 22.5973 13.5995 21.6023 13.1173 20.4381C12.6351 19.2739 12.509 17.9929 12.7548 16.7571C13.0006 15.5212 13.6074 14.386 14.4984 13.495C15.3894 12.604 16.5246 11.9972 17.7605 11.7514C18.9964 11.5055 20.2774 11.6317 21.4415 12.1139C22.6057 12.5961 23.6007 13.4127 24.3008 14.4604C25.0008 15.5082 25.3745 16.7399 25.3745 18H26.0034Z"
                        fill="white"
                      />
                      <path
                        d="M26.0034 18C26.0034 19.3845 25.5929 20.7379 24.8237 21.889C24.0545 23.0401 22.9613 23.9373 21.6822 24.4672C20.4031 24.997 18.9957 25.1356 17.6378 24.8655C16.2799 24.5954 15.0326 23.9287 14.0537 22.9498C13.0747 21.9708 12.408 20.7235 12.1379 19.3656C11.8678 18.0078 12.0065 16.6003 12.5363 15.3212C13.0661 14.0421 13.9633 12.9489 15.1144 12.1797C16.2656 11.4105 17.619 11 19.0034 11V18H26.0034Z"
                        fill="white"
                      />
                      <path
                        d="M10.8464 17.7036C10.8464 16.3102 11.3235 14.6587 12.0659 13.42C12.9672 11.8718 13.9746 11.2524 14.77 10.0654C16.0955 8.15586 16.3606 5.36895 15.5123 3.30456C14.6639 1.18857 12.6491 -0.050058 10.2631 0.00155161C7.93016 0.0531612 5.96836 1.44662 5.22606 3.61422C4.37771 5.93665 4.74886 8.77518 6.65764 10.5299C7.45297 11.2524 8.19527 12.3878 7.7711 13.5233C7.39995 14.5554 6.12743 15.0199 5.22606 15.4328C3.15821 16.3102 0.613175 17.5488 0.189002 19.9745C-0.177004 21.6667 0.0877439 22.4897 0.166498 23.4999C0.187974 23.7754 0.410808 24 0.687127 24H12.384C12.8082 24 13.0733 23.4839 12.8082 23.1742C11.5887 21.626 10.8464 19.7164 10.8464 17.7036Z"
                        fill="white"
                      />
                    </svg>
                  }
                  aria-label="occupancy"
                  iconPosition="top"
                />
                <Tab
                  label="Physical Security"
                  {...a11yProps(2)}
                  sx={{ color: "white", fontSize: "10px" }}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 25 25"
                      fill="none"
                    >
                      <path
                        d="M13.3143 19.6954C13.3143 16.4107 15.977 13.7482 19.2614 13.7482C19.9528 13.7482 20.4001 13.8308 20.869 13.9693C21.1848 14.1032 21.3056 13.8395 21.3385 13.7165C21.5534 12.9139 21.6738 12.0955 21.6738 11.2709C21.6738 11.2157 21.643 4.19622 21.643 4.10951C21.643 3.41725 21.2464 3.41888 21.0693 3.41978C19.7986 3.42582 18.5034 3.42639 17.1409 3.03364C14.3102 2.21748 11.7936 0 10.8369 0C9.91024 0 8.0417 2.21756 5.21091 3.03364C3.61465 3.49385 2.08388 3.40844 0.651803 3.34205C0.48353 3.3343 0.215663 3.28968 0.13067 3.87289C0.109218 4.01987 0 11.192 0 11.2709C0 18.2774 8.66822 24.8585 10.8368 24.8585C11.5307 24.8585 12.6487 24.3012 14.1534 23.1814C14.3539 23.0082 14.2465 22.8934 14.1872 22.7966C13.634 21.8937 13.3143 20.8321 13.3143 19.6954Z"
                        fill="white"
                      />
                      <path
                        d="M19.4073 21.943C19.2069 22.1589 18.8493 22.1923 18.6126 22.0172L14.8464 19.2323C14.6096 19.0572 14.5608 18.7215 14.7379 18.4862L15.2212 17.8447C15.3982 17.6095 15.7374 17.5596 15.9748 17.7338L18.39 19.5061C18.6273 19.6802 18.9854 19.6461 19.1856 19.4301L22.5943 15.8622C22.7946 15.6462 23.1348 15.6337 23.3504 15.8343L23.9382 16.3815C24.1538 16.5821 24.1664 16.9229 23.9661 17.1388L19.4073 21.943Z"
                        fill="white"
                      />
                    </svg>
                  }
                  aria-label="security"
                  iconPosition="top"
                />
                <Tab
                  label="ESG (Environment, Social, and Governance)"
                  {...a11yProps(2)}
                  sx={{ color: "white", fontSize: "10px" }}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 26 26"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.0102 10.8628C12.0068 10.9084 12.0034 10.9542 12 11C11 9 9.7806 6.60243 6.5 5.84503C4.30339 5.33789 0 6.5 0 6.5C0 6.5 2 8 2.5 11C3.08333 14.5 6 15.5 8 15.5C10 15.5 12 14 12 14V24.9988C12 25.5511 12.4477 25.9988 13 25.9988C13.5523 25.9988 14 25.5511 14 24.9988V14C14 14 14.4444 12.2345 17 12.2345C20 12.2345 23.5 10.7597 24 7.31864C24.5 3.87755 26 0.436458 26 0.436458C26 0.436458 22.5 -0.545573 19 0.436458C12.5676 3.35528 12.3322 6.52662 12.0102 10.8628ZM24.1188 1.59257L24.1223 1.58916C24.1223 1.58916 24.117 1.59047 24.1061 1.59382C23.8697 1.6188 20.3659 2.05539 16.5031 6.33113C13.6371 9.50353 13.0028 13.2126 13.0028 13.2126C13.0028 13.2126 13.8221 11.9918 14.8976 10.5398C15.4763 10.3509 16.2322 10.1219 16.841 9.9985C19.4952 9.46048 20.233 9.6682 20.3062 9.69271L20.3106 9.69522L20.3125 9.69494L20.3062 9.69271C20.2249 9.64634 19.0035 8.98027 16.7548 9.45619C16.2147 9.5705 15.7358 9.7565 15.3351 9.95579C16.0327 9.03523 16.7992 8.07654 17.5035 7.31049C22.0988 2.31224 23.9196 1.65144 24.1061 1.59382L24.1188 1.59257ZM9.80387 13.2336L9.80213 13.2327L9.8001 13.2282L9.80387 13.2336ZM9.21625 12.7927C9.21115 12.781 9.19942 12.7561 9.17668 12.7175C8.7383 12.4271 8.00775 12.0158 6.80495 11.4878C5.72828 11.0151 3.99637 10.5471 3.99637 10.5471C3.99637 10.5471 5.49257 10.3272 7.05693 10.998C7.41763 11.1526 7.73407 11.3172 8.01103 11.4842C7.51224 11.0554 6.81143 10.514 5.82885 9.84901C4.56395 8.99291 3.06233 7.0659 3.06233 7.0659C3.06233 7.0659 4.46752 8.03324 6.3103 9.256C8.01511 10.3872 8.73717 11.5754 9.03028 12.2481C9.57897 12.7643 9.77837 13.1806 9.8001 13.2282C9.77747 13.197 9.64532 13.031 9.20276 12.7349C9.21011 12.7638 9.21433 12.7833 9.21625 12.7927ZM9.21625 12.7927C9.21856 12.7981 9.21952 12.8007 9.21952 12.8007L9.21752 12.7992L9.21625 12.7927Z"
                        fill="white"
                      />
                    </svg>
                  }
                  aria-label="security"
                  iconPosition="top"
                />

                <Tab
                  label="Asset Management"
                  {...a11yProps(2)}
                  sx={{ color: "white", fontSize: "10px" }}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="white"
                    >
                      <path d="M200-280v-280h80v280h-80Zm240 0v-280h80v280h-80ZM80-120v-80h800v80H80Zm600-160v-280h80v280h-80ZM80-640v-80l400-200 400 200v80H80Zm178-80h444-444Zm0 0h444L480-830 258-720Z" />
                    </svg>
                  }
                  aria-label="security"
                  iconPosition="top"
                />
              </Tabs>
            </Box>

            {/* Overview*/}
            <CustomTabPanel value={activeTab} index={0}>
              {/* Portfolio Table */}
              <PortfolioGridTable
                title="Contoso Financial"
                content={overviewItem?.length ? overviewItem : []}
              />
            </CustomTabPanel>
            {/* Health & Safety */}
            <CustomTabPanel value={activeTab} index={1}>
              <PortfolioGridHSTable
                title="Contoso Financial"
                content={overviewItem?.length ? overviewItem : []}
              />
            </CustomTabPanel>
            {/* Occupancy */}
            <CustomTabPanel value={activeTab} index={2}>
              <PortfolioGridOCTable
                title="Contoso Financial"
                content={overviewItem?.length ? overviewItem : []}
              />
            </CustomTabPanel>
            {/* Physical Security */}
            <CustomTabPanel value={activeTab} index={3}>
              <PortfolioGridPSTable
                title="Contoso Financial"
                content={overviewItem?.length ? overviewItem : []}
              />
            </CustomTabPanel>
            {/* Physical Security */}
            <CustomTabPanel value={activeTab} index={4}>
              <PortfolioGridESGTable
                title="Contoso Financial"
                content={overviewItem?.length ? overviewItem : []}
              />
            </CustomTabPanel>

            {/* Asset Management */}
            <CustomTabPanel value={activeTab} index={5}>
              <PortfolioGridAMTable
                title="Contoso Financial"
                content={overviewItem?.length ? overviewItem : []}
              />
            </CustomTabPanel>
          </Box>
        </div>
      </div>
    </>
  );
};

export default Portfolio;
